<template>
  <v-card
    :max-height="height"
    :min-height="height"
    class="px-4 tool-card"
    :id="helpCenterId"
    @click="toolCardClicked"
  >
    <slot name="header">
      <v-row class="d-flex justify-space-between my-0">
        <v-col class="pb-0"></v-col>
        <v-col v-if="false && $vuetify.breakpoint.mdAndUp" class="pb-0 d-flex justify-center">
          <img :src="require('@/assets/tools/screener-copy.svg')" class="mt-4 pa-1"
               style="position: relative; height: 48px; background: #f7f7f7;"/>
        </v-col>
        <v-col class="pb-0">
          <p class="tagText mb-0">{{ typeText }}</p>
        </v-col>
      </v-row>
    </slot>
    <slot name="title">
      <v-card-title class="mt-4 pa-0 sectionTitle" style="justify-content: center; padding-top: 10px !important;">
        <fin-subscription-lock v-if="priceModelFeatureId && !isPriceModelFeatureEnabled(priceModelFeatureId)"
                               color="fin-color-primary-dark"/>
        {{ titleText }}
      </v-card-title>
    </slot>
    <slot name="text">
      <v-card-text class="px-0 mb-1"
                   style="display: inline-block; text-align: center; font-size: 14px;  line-height: 1.4;">
        {{ teaserText }}
      </v-card-text>
    </slot>
    <slot name="footer">
      <v-btn v-if="false && $vuetify.breakpoint.mdAndUp" class="px-2 btnStart"
             elevation="0"
             text
             outlined
             tile
             style="justify-items: center; margin-left: 38%; font-size: 12px;"
             :to="to">
        Starten
      </v-btn>
    </slot>
  </v-card>
</template>

<script>
import PriceModel from "@/mixins/PriceModel"
import {PRICEMODEL_FEATURE_RESTRICTIONS} from "@/js/finPriceModel"
import {EventBus} from "@/plugins/fincraft"
import AmplitudePush from "@/mixins/AmplitudePush"
import FinSubscriptionLock from "@/components/common/subscription/lock"

export default {
  name: 'fin-tool-card',
  components: {FinSubscriptionLock},
  mixins: [AmplitudePush, PriceModel],
  props: {
    titleText: {
      type: String
    },
    typeText: {
      type: String
    },
    teaserText: {
      type: String
    },
    toolText: {
      type: String
    },
    height: {
      type: [Number, String]
    },
    helpCenterId: {
      type: String
    },
    to: {
      type: Object
    },
    priceModelFeatureId: {
      type: String
    },
    tracking: {
      type: Object
    }
  },
  methods: {
    toolCardClicked() {
      if (this.priceModelFeatureId && !this.isPriceModelFeatureEnabled(this.priceModelFeatureId)) {
        EventBus.$emit('showSubscriptionPopup', this.priceModelFeatureId, PRICEMODEL_FEATURE_RESTRICTIONS.UNAVAILABLE)
      } else {
        this.$router.push(this.to)
        if (this.tracking) {
          this.pushToAmplitude({
            'event': this.tracking.event('fintools'),
            'step': this.tracking.step,
            'placement': 'fintools',
            'vue_breakpoint': this.$vuetify.breakpoint.name
          })
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.tagText {
  background: $fin-color-page-background;
  padding: 3px;
  text-align: center;
  font-size: 12px;
}

.sectionTitle {
  font-size: 16px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.25;
  letter-spacing: normal;
  margin-bottom: 4px;
  text-decoration: none !important;
}

.btnStart {
  float: bottom;
  border: 2px solid $fin-color-primary-dark !important;
  -moz-border-radius: 0 !important;;
  -webkit-border-radius: 0 !important;;
  -ms-border-radius: 0 !important;
  border-radius: 0 !important;
  width: 76px;
  height: 33px;
  font-weight: bold;
}

.tool-card {
  box-shadow: $fin-color-card-shadow !important;
  border: 1px solid $fin-color-light-sky-blue;
}
</style>
